module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Twitter List Widget */

(function(fox) {

	fox.registerWidget('Twitter', {

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'SocialNetwork.getPosts',
						cacheChannel: 'snLocal',
						transitParameters: {
							alias: 'twitter'
						},	
					},
					viewMore: {
						widget: 'Widget',
						'widgets.socialNetworkApi': {
							widget: 'Api',
							method: 'SocialNetwork.getByAlias',
							cacheChannel: 'site'
						},
						'handleWom.socialNetworkApi': {
							widget: '#socialNetworkApi',
							event: 'ready',
							callback: function(response) {
								this.setTemplateOptions(response);
								this.render();
							}
						},
						'hooks.onRunning': function() {
							this.rwom1('#socialNetworkApi').send({
								alias: 'twitter'
							});
						},
						embed: {
							widget: '@parent',
							container: '.view'
						},
						autoRender: false,
						template: 'twitter_view_more'

					}
				},
				container: '#twit_block',
				template: 'twitter_grid',
				list: {
					container: '#twits.twits-list',
					'tpl.row': 'twitter_list',
					'handleWom.addedToDom': {
						widget: '@this',
						event: 'addedToDom',
						callback: '@parent:addedToDomList'
					}
				},

			});
			fox.registerTemplateModifier('nofollow', function (obj) {
				if (fox.isEmpty(obj)) return;
				var obj1 = obj.replace(/<a href/g, '<a rel="nofollow" href');
				return obj1;
			});
			this.callParent('configure', arguments);
		},

		addedToDomList: function() {
			fox.each(this.dl.getCollection(), function(obj, id) {
				var elm = fox.dom.selectFirst('[data-id="' + id + '"]', this.element[0]);
				if (!fox.isEmpty(elm)) {
					elm.innerHTML = obj.postText;
				}
			}, this);
		},

		init: function() {
			this.handleEvent(this, 'updated', fox.bind(this.render, this));
			this.callParent('init', arguments);
		},

		rendering: function () {
			this.callParent('rendering', arguments);
			
			if (!this.dl.getCount()) {
				//clean fragment if no twits
				this.fragment = document.createDocumentFragment();
			}
		}

	}, 'Grid');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/twitter.js
// module id = 934
// module chunks = 4